import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AddDocumentComponent } from './add-document/add-document.component';
import { FilePreviewComponent } from './file-preview/file-preview.component';

@Component({
  selector: 'app-knowledge-docs',
  templateUrl: './knowledge-docs.component.html',
  styleUrl: './knowledge-docs.component.scss'
})
export class KnowledgeDocsComponent implements OnInit {
  
  constructor(
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private securityService: SecurityService,
    private modalService: BsModalService,
    private router: Router,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private HeaderComponent: HeaderComponent
  ) {
  }

  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  searchValue: string = '';
  filterVal: string = '';
  loading: boolean = false;
  modalRef?: BsModalRef;
  showAddNewFile: boolean = false;
  
  knowledgeDocs: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];
   cols: any = [
    { name: 'ID', label: 'ID', showFilter: true, hide: true },
    { name: 'name', label: 'Document Name', showFilter: true },
    { name: 'uploadedDate', label: 'Date Uploaded', type: 'date', showFilter: true },
    { name: 'uploadedBy', label: 'Uploaded By', showFilter: true },
    { name: 'download', label: 'Download', showFilter: false , sortable: false, format: 'html' },
    { name: 'remove', label: 'Remove', showFilter: false, sortable: false, format: 'html' },
    { name: 'previewUrl', label: 'Preview', showFilter: false, sortable: false, hide: true },
  ];

   localStorageName = 'knowledgeColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  ngOnInit(): void {
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = 'Knowledge Docs';//this.currentMenu.name;
    });
    this.loadKnowledgeDocs();
    this.initializeColumnHeader();
    for (const col of this.cols) {
      console.log('Column:', col.name, 'Hide:', col);
      if (col.name === 'ID' || col.name === 'previewUrl') {
        col.hide = true;
      }
    }
  }
  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }
  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  removeFile(event: any) {
    if (event) {
      const index = this.dataToDisplay.indexOf(event); 
      console.log('Removing file:', event, 'at index:', index); 
    }
  }
  downloadFile(event: any) {
    if (event) {
      this.previewFile(event);
    }
  }

   onRowSelect(event: any) {
    //this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (!col.filterVals) {
          // Get unique values from the filtered data for this column
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]).filter(val => val != null))];
          const filterData: any = [];
          for (const val of unique) {
            // All values start unchecked when creating for the first time
            filterData.push({ name: val.toString(), checked: false });
          }
          col.filterVals = filterData;
        }
        // If filterVals already exists, we preserve the existing checked states automatically
      }
    }
    //this.showColumnFilterModal(colName);
  }
  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }
  searchKnowledge(event) {

  }
  showUploadFileModal() {
    const config: ModalOptions = {
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modalService.show(AddDocumentComponent, config);
  }

  previewFile(file: any) {
    if (!file) {
      return;
    }

    const fileUrl = file.previewUrl ? file.previewUrl : 'assets/images/icon-upload.png';
    const config: ModalOptions = {
      class: 'modal-lg',
      backdrop: 'static',
      keyboard: false,
      initialState: {
        fileName: file.name || 'Preview',
        fileUrl: fileUrl
      }
    };
    this.modalRef = this.modalService.show(FilePreviewComponent, config);
  }

 
  loadKnowledgeDocs() {
    this.loading = true;
    this.dataToDisplay = this.knowledgeDocs;
    this.filteredData = this.knowledgeDocs;
    this.setInnerWidthHeightParameters();

  }

   setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
}
